import { AnyAction } from "redux";
import { RetailerFwaState } from "../../../../../models/state";
import { fulfilled, pending, rejected } from "../../utils";
import * as AT from "../actionTypes";

const initialState: RetailerFwaState = {
    coverageStatus: "idle",
    coverageError: undefined,
    isTraadlosTabActive: false,
    packages: [],
    selectedPackageId: null,
    validAddressId: undefined,
};

const fwaReducer = (state = initialState, action: AnyAction): RetailerFwaState => {
    switch (action.type) {
        case pending(AT.RETAILER_FWA_CHECK_COVERAGE): {
            return {
                ...state,
                coverageStatus: "loading",
                coverageError: undefined,
                packages: [],
                selectedPackageId: null,
                validAddressId: undefined,
            };
        }
        case fulfilled(AT.RETAILER_FWA_CHECK_COVERAGE): {
            const { hasFwa, packages, validAddressId } = action.payload as {
                hasFwa: boolean;
                packages: RetailerFwaState["packages"];
                validAddressId?: number;
            };
            return {
                ...state,
                coverageStatus: hasFwa ? "covered" : "no_coverage",
                packages: hasFwa ? (packages ?? []) : [],
                validAddressId,
            };
        }
        case rejected(AT.RETAILER_FWA_CHECK_COVERAGE): {
            const errorPayload = action.payload;
            const coverageError =
                errorPayload instanceof Error
                    ? errorPayload.message
                    : typeof errorPayload === "string"
                      ? errorPayload
                      : "Kunne ikke sjekke dekning. Prøv igjen.";
            return {
                ...state,
                coverageStatus: "error",
                coverageError,
            };
        }
        case AT.RETAILER_FWA_SET_SELECTED_PACKAGE: {
            return {
                ...state,
                selectedPackageId: action.payload,
            };
        }
        case AT.RETAILER_FWA_SET_TRADLOS_TAB_ACTIVE: {
            return {
                ...state,
                isTraadlosTabActive: action.payload as boolean,
            };
        }
        default:
            return state;
    }
};

export default fwaReducer;
